<template>

    <v-card :loading="loading" max-width="600">
        <v-card-title>
            <TitleOfDialog title="Upload descriptive" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-form ref="vehicleForm">
                <DescriptiveInput v-model:descriptive-file="descriptiveFile"></DescriptiveInput>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn :disabled="loading" @click="validate()" class="w-100" color="primary" variant="elevated"
                text="Upload descriptive file"></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="js">
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { ref } from 'vue';
import DescriptiveInput from './DescriptiveInput.vue';
import { useVehicleStore } from '@/store/vehicleStore';
import { useNotificationStore } from '@/store/notificationStore';

const vehicleStore = useVehicleStore();
const vehicleForm = ref();
const props = defineProps({
    vehicle: Object
})

const descriptiveFile = ref();
const loading = ref(false);
const emit = defineEmits(['close', 'persistent'])

const validate = async () => {
    const isValid = await vehicleForm.value?.validate();
    if (isValid.valid) {
        emit('persistent', true);
        loading.value = true;
        try {
            const text = await descriptiveFile.value.text();
            const descriptiveJson = JSON.parse(text);
            await vehicleStore.uploadDescriptive(props.vehicle.id, descriptiveJson);
            useNotificationStore().setNotification("Vehicle updated sucessfully", "Vehicle " + props.vehicle.name + " has been updated sucessfully.", "mdi-alert", "success");
            loading.value = false;
            emit('close');
        } catch (error) {
            loading.value = false;
            console.error("Error en la validación o creación de la mision:", error);
        }
    } else {
        console.log("Formulario no válido:", isValid);
    }
}
</script>